var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo-background",attrs:{"src":require("@/assets/Shape.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }